var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._b({},'div',
    _vm.setTextColor(_vm.color, {
      staticClass: 'v-messages',
      class: _vm.themeClasses
    })
  ,false),[_c('transition-group',{staticClass:"v-messages__wrapper",attrs:{"tag":"div","name":"message-transition"}},_vm._l((_vm.value),function(message,key){return _c('div',{key:key,staticClass:"v-messages__message"},[_vm._t("default",[_vm._v(" "+_vm._s(message)+" ")],null,{ message: message, key: key })],2)}),0)],1)}
var staticRenderFns = []

export { render, staticRenderFns }